"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Only capture in production or when Sentry is enabled
    if (process.env.NEXT_PUBLIC_ENABLE_SENTRY?.toLowerCase() === "true") {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <html dir="rtl" lang="fa">
      <body className="min-h-screen flex flex-col gap-4 items-center justify-center">
        <h2>مشکلی پیش آمد</h2>
        <button
          className="mx-auto primary-btn px-3 py-1"
          onClick={() => reset()}
        >
          تلاش دوباره
        </button>
      </body>
    </html>
  );
}
